var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('float-button',{attrs:{"side":_vm.side,"icon":_vm.icon,"title":_vm.title,"color":_vm.color},on:{"action":function($event){return _vm.ghostSubmit()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5931d7f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FloatSubmitButton.vue
// module id = 1033
// module chunks = 0